import { Component, Input } from '@angular/core';
import { AircraftProfileService } from 'src/modules/ald-aircraft-profile/_services/aircraft-profile.service';
import { IAircraftProfile } from 'src/modules/shared/interfaces/IAircraftProfile';
import { IKeyValuePair } from 'src/modules/shared/interfaces/IKeyValuePair';
import {IAmoDto} from "../../../shared/interfaces/IAmoDto";

@Component({
  selector: 'app-related-amos-table',
  templateUrl: './related-amos.component.html',
  styleUrls: ['./related-amos.component.css'],
})
export class RelatedAmosComponent {
  @Input() relatedAmos: IAmoDto[] = [];
  @Input() isRequired: boolean;
  @Input() showError: boolean;
  @Input() IsReadOnly : boolean;

  // ngOnInit(){
  //   if (!this.relatedAmos) this.relatedAmos = [];
  // }
  handleChecked(checkedAmo) {
  }
}
